










const name = 'ttam-select-panel-empty';
export default {
  name,
  props: {
    emptyText: {
      type: String,
      default: '',
    },
  },
};
